import React, { useState } from 'react';
import './App.css';

// STYLES
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';
import teal from '@material-ui/core/colors/teal';
import './index.css';

import { QueryClient, QueryClientProvider } from 'react-query';
import HRCostsState from 'context/hrcosts/hrCostsState';
import PartnersState from 'context/partners/partnersState';
import ProjectsState from 'context/projects/projectsState';
import SearchState from 'context/search/searchState';
import AllowanceState from './context/allowance/AllowanceState';
import ExternalUsersState from './context/externalUsers/externalUsersState';
import InventoryState from './context/inventory/inventoryState';
import ProfilesState from './context/profiles/ProfilesState';
import UsersState from './context/users/usersState';
import HrModuleState from './context/hrModule/hrModuleState';
import LibraryModuleState from './context/libraryModule/libraryModuleState';
import QuotasModuleState from './context/quotaModule/quotaModuleState';
import IdleTimer from './IdleTimer';
import './i18n';

// Snackbar Provider
import { SnackbarProvider } from 'hooks/UseSnackbar';
import DialogIncompatibility from 'components/dialogs/DialogIncompatibility';

import { isSafari, browserVersion } from 'react-device-detect';
import Routes from 'routes';

//source: https://material-ui.com/pt/customization/color/
const theme = createTheme({
  palette: {
    primary: {
      main: '#2c3e51'
    },
    secondary: {
      main: '#ffffff'
    },
    danger: {
      main: '#bb2124'
    },
    red: {
      light: red[100],
      main: red[300],
      dark: red[600],
      darkest: red[800]
    },
    teal: {
      light: teal[100],
      main: teal[300],
      dark: teal[600],
      darkest: teal[800]
    },
    grey: {
      light: grey[100],
      main: grey[300],
      dark: grey[600],
      darkest: grey[800]
    }
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false
    }
  }
});

const App = () => {
  const [openDialogIncompability, setOpenDialogIncompatibility] = useState(
    localStorage.getItem('incompatibility-dialog') !== null ? false : true
  );

  return (
    <div>
      <IdleTimer />
      <MuiThemeProvider theme={theme}>
        {isSafari && parseInt(browserVersion) < 14 ? (
          <DialogIncompatibility
            open={openDialogIncompability}
            setOpen={setOpenDialogIncompatibility}
          />
        ) : null}
        {/* <CookiesProvider> */}
        <QueryClientProvider client={queryClient}>
          <SnackbarProvider>
            <AllowanceState>
              <ProfilesState>
                <UsersState>
                  <PartnersState>
                    <ProjectsState>
                      <HRCostsState>
                        <SearchState>
                          <InventoryState>
                            <ExternalUsersState>
                              <HrModuleState>
                                <LibraryModuleState>
                                  <QuotasModuleState>
                                    <Routes />
                                  </QuotasModuleState>
                                </LibraryModuleState>
                              </HrModuleState>
                            </ExternalUsersState>
                          </InventoryState>
                        </SearchState>
                      </HRCostsState>
                    </ProjectsState>
                  </PartnersState>
                </UsersState>
              </ProfilesState>
            </AllowanceState>
            {/* </CookiesProvider> */}
          </SnackbarProvider>
        </QueryClientProvider>
      </MuiThemeProvider>
    </div>
  );
};
export default App;
